module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-ramen@2x-c5cbd93c631425614d8ce120f630474c.png";